import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FacultyEnrollmentForm from './FacultyEnrollmentForm';
import apiService from '../../services/api';
import { useNotification } from '../../contexts/NotificationContext';
import ConfirmModal from '../Notification/ConfirmModal';

import styles from '../../styles/FacultyEnrollment.module.css';

const FacultyEnrollmentPage: React.FC = () => {
    const notification = useNotification();
    const navigate = useNavigate();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (data: any) => {
        setIsSubmitting(true);
        try {
            // Call API
            const response = await apiService.post('/api/auth/faculty/enroll/', data);

            // Set message and show modal
            setSuccessMessage(response.message || 'Enrollment request submitted successfully. Waiting for admin approval.');
            setShowSuccessModal(true);

        } catch (error: any) {
            console.error('Enrollment error:', error);
            const errorMsg = error.response?.data?.error || 'Failed to submit enrollment.';
            notification.error(errorMsg);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSuccessClose = () => {
        setShowSuccessModal(false);
        // Navigate or reset form? For now, maybe navigate to home or signin
        navigate('/auth/signin');
    };

    return (
        <div className={styles.pageContainer}>
            <div className={styles.card}>
                <h1 className={styles.title}>
                    Faculty Enrollment
                </h1>
                <FacultyEnrollmentForm onSubmit={handleSubmit} isLoading={isSubmitting} />

                <ConfirmModal
                    isOpen={showSuccessModal}
                    title="Enrollment Submitted"
                    message={successMessage}
                    okText="Close"
                    showCancel={false}
                    onConfirm={handleSuccessClose}
                    onCancel={handleSuccessClose}
                />
            </div>
        </div>
    );
};

export default FacultyEnrollmentPage;
